import React, { useEffect } from 'react';
import { ModalProvider } from './context/ModalContext';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Marquee from './components/Marquee/Marquee';
import Stats from './components/Stats/Stats';
import Features from './components/Features/Features';
import ApplicationForm from './components/ApplicationForm/ApplicationForm';
import FlightPerks from './components/FlightPerks/FlightPerks';
import NMCGuidelines from './components/NMCGuidelines/NMCGuidelines';
import DocumentsSection from './components/DocumentsSection/DocumentsSection';
import Timeline from './components/Timeline/Timeline';
import FAQ from './components/FAQ/FAQ';
import Footer from './components/Footer/Footer';
import PopupModal from './components/PopupModal/PopupModal';

import './styles/global.css';
import './App.css';

function AppInner() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            setTimeout(() => entry.target.classList.add('in'), i * 80);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />            {/* id="home" */}
      <Marquee />
      <Stats />           {/* id="about" */}
      <Features />        {/* id="features" */}
      <ApplicationForm /> {/* id="apply" — Why Choose Us */}
      <FlightPerks />     {/* id="flight-perks" — Free Flight & Pick-Drop */}
      <NMCGuidelines />   {/* id="nmc-guidelines" */}
      <DocumentsSection />{/* id="documents" */}
      <Timeline />        {/* id="process" */}
      <FAQ />             {/* id="faq" */}
      <Footer />
      <PopupModal />
    </div>
  );
}

function App() {
  return (
    <ModalProvider>
      <AppInner />
    </ModalProvider>
  );
}

export default App;